// Rendering for the grouped patient/Rx search results. Shared so that every
// patient picker shows the same "Aktueller Standort" / "Andere Standorte"
// sections in the same way.

import React from "react";
import { AutocompleteRenderGroupParams } from "@mui/material/Autocomplete";
import { Box, Chip, Divider, Typography } from "@mui/material";
import {
  PATIENT_SEARCH_GROUP_LABELS,
  PatientSearchGroup,
  PatientSearchOption,
} from "../stores/Patients/patient.search";

export const renderPatientSearchGroup = (params: AutocompleteRenderGroupParams) => (
  <li key={params.key}>
    <Box sx={{ px: 1.5, pt: 1 }}>
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {PATIENT_SEARCH_GROUP_LABELS[params.group as PatientSearchGroup] ?? params.group}
      </Typography>
    </Box>
    <Divider sx={{ mb: 0.5 }} />
    <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>{params.children}</ul>
  </li>
);

export const renderPatientSearchOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: PatientSearchOption,
) => (
  <li
    {...props}
    key={`${option.kind}-${option.id}`}
    style={{
      ...(option.isEmptyPlaceholder && {
        pointerEvents: "none",
        opacity: 0.6,
        fontStyle: "italic",
      }),
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.5, px: 1 }}>
      <Typography
        variant="body2"
        sx={{
          flex: 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...(option.isEmptyPlaceholder && {
            fontStyle: "italic",
            color: "text.secondary",
          }),
        }}
      >
        {option.label}
      </Typography>
      {!option.isEmptyPlaceholder && !option.locationMatch && (
        <Chip size="small" label={option.locationName ?? "Andere"} variant="outlined" />
      )}
    </Box>
  </li>
);
